import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

import { DetailsType } from './constants'
import useStyles from './useStyles'

interface Props {
  detailsType: DetailsType
  percent?: number | null
}

const DETAILS_TYPE = {
  [DetailsType.DEFAULT]: '',
  [DetailsType.L4L]: 'L4L',
  [DetailsType.RETAIL]: 'RETAIL',
  [DetailsType.ECOM]: 'ECOM',
  [DetailsType.BUDGET]: 'BUDGET',
}

function DetailsTypeBadge({ detailsType, percent }: Props) {
  const { t: translate } = useTranslation()
  const classes = useStyles({ detailsType, percent })
  const label = detailsType === DetailsType.BUDGET ? translate('revenue.budget') : DETAILS_TYPE[detailsType]

  if (detailsType === DetailsType.DEFAULT) return null

  return (
    <Box className={classes.detailsType}>
      <div>{label}</div>
    </Box>
  )
}

export default memo(DetailsTypeBadge)
